import { type GroupId } from 'interfaces/groups';

export const GENERAL_GROUP_ID: GroupId = '0';

export enum GroupStatus {
  Online = 'online',
  Offline = 'offline',
}
